import { NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { ContactGroupModule } from '../contact-group/contact-group.module';
import { ContactComponent } from './contact.component';
import { CardComponentModule } from "lib-trend-core";
import { ContactRoutingModule } from './contact-routing.module';
import { ContactViewComponent } from './contact-view/contact-view.component';
import { ContactViewAttendanceListComponent } from './contact-view/contact-view-attendance-list/contact-view-attendance-list.component';
import { ContactViewNoteEditComponent } from './contact-view/contact-view-note-edit/contact-view-note-edit.component';
import { ContactListComponent } from './contact-list/contact-list.component';
import { ContactCustomerPortifolioComponent } from './contact-customer-portfolio/contact-customer-portfolio.component';
import { ContactCustomerPortfolioTransferComponent } from './contact-customer-portfolio-transfer/contact-customer-portfolio-transfer.component';

@NgModule({
  imports: [
    SharedModule,
    ContactGroupModule,
    CardComponentModule,
    ContactRoutingModule
],
  declarations: [
    ContactComponent,
    ContactViewComponent,
    ContactViewAttendanceListComponent,
    ContactViewNoteEditComponent,
    ContactListComponent,
    ContactCustomerPortifolioComponent,
    ContactCustomerPortfolioTransferComponent
  ],
  exports: [
    ContactComponent,
    ContactViewComponent,
    ContactViewAttendanceListComponent,
    ContactViewNoteEditComponent,
    ContactListComponent,
    ContactCustomerPortifolioComponent,
    ContactCustomerPortfolioTransferComponent
  ]
})
export class ContactModule { }
